module.exports = __webpack_public_path__ + "img/CAT.56eea15.svg";